import { GridCellProps } from "@progress/kendo-react-grid";
import React from "react";
import { VarianceStartCommand } from "../../../../../services/varianceService/commands";
import { useStartPatientVarianceMutation } from "../../../../../services/varianceService/variance-api";
import { GridButton } from "../../../../../components";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { useNavigate } from "react-router";
import { setVarianceIndividual } from "../../../../../services/varianceService/model/varianceRequest/VarianceRequestSlice";
import { DefaultVarianceRequest } from "../../../../../services/varianceService/model/varianceRequest/VarianceRequest";
import { toggleInitiatePatientSearchDialog } from "../../../../../app/slices/VarianceModuleSlice";

function VarianceInitiateCommand(props: GridCellProps) {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
 const variance = useAppSelector(
    (state) => state.varianceRequest.varianceRequest
  );
  const varianceStart = DefaultVarianceRequest();

  Object.assign(varianceStart, variance);
  Object.assign(varianceStart, props.dataItem);
  Object.assign(varianceStart.individual, {
    mrn: props.dataItem.mrn,
    firstName: props.dataItem.firstName,
    lastName: props.dataItem.lastName,
    age: props.dataItem.age,
    sex: props.dataItem.sex,
    homePhone: props.dataItem.homePhone,
    mobilePhone: props.dataItem.mobilePhone,
    email: props.dataItem.email,
    individualType: "Patient",
  });
  varianceStart.varianceStartDate = new Date().toISOString();


  const [initiate] = useStartPatientVarianceMutation();
  const saveIdent = () => {
    dispatch(setVarianceIndividual(varianceStart.individual));
    startVariance();
    dispatch(toggleInitiatePatientSearchDialog());
  };
  
  const startVariance = () => {
    const command = new VarianceStartCommand(varianceStart);
    initiate(command)
      .unwrap()
      .then((fullfilled) => {
        navigate("/varianceRequestDetail/" + fullfilled.id);
      });
      dispatch(setVarianceIndividual(DefaultVarianceRequest().individual));
  };

  const [isLoading, setIsLoading] = React.useState(false);

  return (
    <React.Fragment>
      <GridButton
        onClick={() => {
          setIsLoading(true);
          saveIdent();
        }}
        disabled={isLoading}
      >
        {isLoading ? "Loading..." : "Initiate"}
      </GridButton>
    </React.Fragment>
  );
}

export { VarianceInitiateCommand };
